import React from 'react';
import Form from 'react-bootstrap/Form';
import { Col, Container, Row, Button, OverlayTrigger, Popover } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import ChemEdit from '../ChemEdit';
import ADACheckbox from '../ADACheckbox';
import { Link } from 'react-router-dom';

class Microrequest extends ChemComponent {
	constructor(props) {
		super(props);
		
		this.state = {
			request: {
				microrequest: {
					IDDISPLAY: '',
				},
				users: {
					AFFILIATIONDISPLAY: ''
				}
			},
			requestColumns: this.filterColumns(requestColumns),
			renderKey: 0
		}
	}	

	componentDidMount() {
		this.loadRequest();
	}
	
	componentDidUpdate(prevProps) {
		if (this.props.params.userId !== prevProps.params.userId ||
			this.props.params.requestId !== prevProps.params.requestId) {
			this.loadRequest();
		}
	}

	loadRequest(event) {
		var self = this;

		this.ajax({
			type: 'post',
			url: this.getConfig().host + '/FAS/GetMicrorequest',
			data: { 
				__RequestVerificationToken: this.props.user.antiForgeryToken,
				request: {
					id: this.props.params.requestId,
					userid: this.props.params.userId
				}
			}
		}).done(function (data) {
			if (data.Success) {
				var request = data.Data;
			
				// convert from mvc to js
				self.mvc2js(request, requestColumns);
				
				// convert checkboxes
				for (var i = 0; i < checkboxes.length; i++) {
					request.microrequest[checkboxes[i]] = request.microrequest[checkboxes[i]] === 1;
				}
				
				// initialize fields
				if (self.props.params.requestId) {
					// add prefix to ID for display
					request.microrequest.IDDISPLAY = 'M-' + request.microrequest.ID;
					
					// interpret flourine as strictly Y/N since it is required on initial sumbit
					request.microrequest.FLOURINE = request.microrequest.FLOURINE === 1;
				} else {
					// indicate new request
					request.microrequest.IDDISPLAY = '(new)';
					
					// ICP default 1 (yes)
					request.microrequest.ICP = 1;
					
					// service default ICP
					request.microrequest.SERVICE = 'ICP';
					
					// set request date
					request.microrequest.REQUESTDATE = self.dateTimeToMVC(new Date());
					
					// set user ID
					request.microrequest.USERID = self.props.params.userId;
					
					// set facility ID to Microrequest
					request.microrequest.FACILITIESID = 34;
					
					// no answer for flourine yet
					request.microrequest.FLOURINE = null;
				}
					
				// interpret affiliation for display
				if (request.users.AFFILIATION === 'chem') {
					request.users.AFFILIATIONDISPLAY = 'Chemistry';
				} else if (request.users.AFFILIATION === 'affil') {
					request.users.AFFILIATIONDISPLAY = 'Affiliate';
				} else if (request.users.AFFILIATION === 'non') {
					request.users.AFFILIATIONDISPLAY = 'Non UC users';
				} else {
					request.users.AFFILIATIONDISPLAY = '(unknown)';
				}
				
				// if there is no PO number in the request
				if (self.isEmpty(request.microrequest.PONUMBER)) {
					// get the user's default purchase order
					request.microrequest.PONUMBER = request.users.PURCHASEORDER;
				}
				
				if (request.users.AFFILIATION !== 'non') {
					// if there is no speedtype in the request
					if (self.isEmpty(request.microrequest.SPEEDCODE)) {
						// get the user's default speedcode
						request.microrequest.SPEEDCODE = request.users.SPEEDCODE;
					}
				}
				
				// set lab rates
				self.setLabRates(request);
					
				self.mergeStateWithArrays({
					request: request,
					requestColumns: self.filterColumns(requestColumns, [request.users.AFFILIATION, 'icp' + (+request.microrequest.ICP === 1 ? 'yes' : 'no')]),
					renderKey: self.state.renderKey + 1
				}, () => {
					if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();
				});
			} else {
				self.showAlert('Server Error', data.Message);
			}			
		}).fail(function (jqXHR, textStatus, errorThrown) {
			self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
		});
	}
	
	isEditable() {
		// if props say not editable, that overrides below logic
		if (!this.props.editable) return false;
		
		// if admin is logged in, or request is new and for logged in user
		return (('' + this.props.user.uid).startsWith('fas.admin.') ||
			(this.props.user.fas && this.props.user.fas.authLevel === 1) ||
			(!this.props.params.requestId &&
				('' + this.props.user.uid).startsWith('fas.user.') &&
				+this.props.user.uid.substring(9) === +this.props.params.userId));
	}
	
	isICPEditable() {
		// if props say not editable, that overrides ICP logic
		if (!this.props.editable) return false;
		
		// if this is an ICP request and it has not been completed yet
		return (this.state.request.microrequest.ICP === 1 && this.state.request.microrequest.STATUS !== 'Completed');
	}
	
	isDeletable() {
		// if props say not editable that overrides below logic
		if (!this.props.editable) return false;
		
		// must be saved in the database and not transferred or billed yet
		return (this.props.params.requestId && 
			this.isEmpty(this.state.request.microrequest.BILLINGDATE) &&
			this.isEmpty(this.state.request.microrequest.TRANSFER_FLAG));
	}
		
	onChange(accessor, value) {
		var request = this.copyObject(this.state.request);
			
		this.setByAccessor(request, accessor, value);
		this.setLabRates(request);
		
		// if there is enough information to set the service total
		if (this.isNumeric(request.microrequest.SERVICEAMOUNT) &&
			this.isNumeric(request.microrequest.LABOR) &&
			this.isNumeric(request.microrequest.MATERIALS)) {
			request.microrequest.SERVICETOTAL = +request.microrequest.SERVICEAMOUNT * ((+request.microrequest.LABOR) + (+request.microrequest.MATERIALS));
		} else {
			request.microrequest.SERVICETOTAL = '';
		}
		
		this.setState({
			request: request,
			requestColumns: this.filterColumns(requestColumns, [request.users.AFFILIATION, 'icp' + (+request.microrequest.ICP === 1 ? 'yes' : 'no')]),
			renderKey: this.state.renderKey + 1
		});
	}
	
	setLabRates(request) {
	  if (request.microrequest.AFFILIATION === 'non') {
		if (request.microrequest.SERVICE === 'CHN') {
			request.microrequest.LABOR = request.labrates.CHNOUT;
			request.microrequest.MATERIALS = request.labrates.CHNOUTMATERIAL;
		} else if (request.microrequest.SERVICE === 'CHNA') {
			request.microrequest.LABOR = request.labrates.CHNAOUT;
			request.microrequest.MATERIALS = request.labrates.CHNAOUTMATERIAL;
		} else if (request.microrequest.SERVICE === 'CHNS') {
			request.microrequest.LABOR = request.labrates.CHNSOUT;
			request.microrequest.MATERIALS = request.labrates.CHNSOUTMATERIAL;
		} else if (request.microrequest.SERVICE === 'CHNS+CHNA') {
			request.microrequest.LABOR = request.labrates.CHNS_CHNA_LABOR;
			request.microrequest.MATERIALS = request.labrates.CHNS_CHNA_MATERIAL;
		} else if (request.microrequest.SERVICE === 'ICP') {
			request.microrequest.LABOR = request.labrates.ICP;
			request.microrequest.MATERIALS = request.labrates.ICPMATERIAL;
		} else if (request.microrequest.SERVICE === 'Consulting' ) {
			request.microrequest.LABOR = request.labrates.CONSULTINGOUT;
			request.microrequest.MATERIALS = 0;
		} else {
			request.microrequest.LABOR = '';
			request.microrequest.MATERIALS = '';
		}
	  } else {
		if (request.microrequest.SERVICE === 'CHN') {
			request.microrequest.LABOR = request.labrates.CHN;
			request.microrequest.MATERIALS = request.labrates.CHNMATERIAL;
		} else if (request.microrequest.SERVICE === 'CHNA') {
			request.microrequest.LABOR = request.labrates.CHNA;
			request.microrequest.MATERIALS = request.labrates.CHNAMATERIAL;
		} else if (request.microrequest.SERVICE === 'CHNS') {
			request.microrequest.LABOR = request.labrates.CHNS;
			request.microrequest.MATERIALS = request.labrates.CHNSMATERIAL;
		} else if (request.microrequest.SERVICE === 'CHNS+CHNA') {
			request.microrequest.LABOR = request.labrates.CHNS_CHNA_LABOR;
			request.microrequest.MATERIALS = request.labrates.CHNS_CHNA_MATERIAL;
		} else if (request.microrequest.SERVICE === 'ICP') {
			request.microrequest.LABOR = request.labrates.ICP;
			request.microrequest.MATERIALS = request.labrates.ICPMATERIAL;
		} else if (request.microrequest.SERVICE === 'Consulting' ) {
			request.microrequest.LABOR = request.labrates.CONSULTING;
			request.microrequest.MATERIALS = 0;
		} else {
			request.microrequest.LABOR = '';
			request.microrequest.MATERIALS = '';
		}
	  }
	}

	filterColumns(columns, filter) {
		var i;
		var newColumns = [];
		var rows = [];
		var filters = Array.isArray(filter) ? filter : [filter];
		
		if (('' + this.props.user.uid).startsWith('fas.admin.') ||
			(this.props.user.fas && this.props.user.fas.authLevel === 1)) {
			filters.push('admin');
		} else if (('' + this.props.user.uid).startsWith('fas.user.') ||
			(this.props.user.fas && this.props.user.fas.authLevel > 1)) {
			filters.push('user');
		}
		
		// filter out columns that are specifically excluded by the filters
		for (i = 0; i < columns.length; i++) {
			if (!columns[i].includedby ||
				(Array.isArray(columns[i].includedby) && columns[i].includedby.some(f => filters.includes(f))) ||
				(columns[i].includedby && filters.includes(columns[i].includedby))) {
				// make a copy of the column
				var newColumn = this.copyColumn(columns[i]);
				
				// add to new list of columns
				newColumns.push(newColumn);
				
				// if this column's row is not already represented
				if (!rows.includes(newColumn.row)) {
					// add to list of occupied rows
					rows.push(newColumn.row);
				}
			}
		}
		
		// sort list of occupied rows
		rows.sort((a, b) => a - b);
		
		// remove any empty rows by using sorted array as a map
		for (i = 0; i < newColumns.length; i++) {
			// search the sorted array to find the new row index
			for (var r = 0; r < rows.length; r++) {
				if (newColumns[i].row === rows[r]) {
					newColumns[i].row = r;
					break;
				}
			}
		}

		return newColumns;
	}
	
	validateRequest(event, columns, data) {
		if (this.isEditable() || this.isICPEditable()) {
			var errmsg = this.validate(columns, data);
			
			// if service indicates air sensitive
			if (['CHNA','CHNS+CHNA'].includes(data.microrequest.SERVICE) && !data.microrequest.AIRSEN) {
				// insist that air sensitive checkbox is checked
				if (!this.isEmpty(errmsg)) {
					errmsg += '; ';
				} else {
					errmsg = '';
				}
				errmsg += "Service is '" + data.microrequest.SERVICE + "' but 'Air Sensitive' is not checked.";  
			} else if (['CHN','CHNS'].includes(data.microrequest.SERVICE) && data.microrequest.AIRSEN) {
				// insist that air sensitive checkbox is not checked
				if (!this.isEmpty(errmsg)) {
					errmsg += '; ';
				} else {
					errmsg = '';
				}
				errmsg += "Service is '" + data.microrequest.SERVICE + "' but 'Air Sensitive' is checked.";  
			}
			return errmsg;
		} else {
			return 'Request cannot be modified.';
		}
	}
	
	onClickDelete() {
		var self = this;
		
		this.showOKCancel('Confirm Delete', 'Delete microrequest ' + this.props.params.requestId + '?', (okClicked) => {
			self.ajax({
				type: 'post',
				url: self.getConfig().host + '/FAS/DeleteMicrorequest',
				data: { 
					__RequestVerificationToken: self.props.user.antiForgeryToken,
					requestid: this.props.params.requestId
				}
			}).done(function (data) {
				if (data.Success) {
					self.props.parent.showConfirmation(() => {
						return (<>
							Request {self.props.params.requestId} deleted.
						</>);
					});
				} else {
					self.showAlert('Server Error', data.Message);
				}			
			}).fail(function (jqXHR, textStatus, errorThrown) {
				self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
			});
		});
	}

	onSubmit(event) {
		var self = this;
		var request = this.copyObject(this.state.request.microrequest);
		this.js2mvc(request, requestColumns);
		
		// default no email sent
		request.SEND_COMPLETION_EMAIL = false;
		
		// if complete is checked but there is no completion date
		if (request.COMPLETE && this.isEmpty(request.DATECOMP)) {
			// set the completion date
			request.DATECOMP = this.dateTimeToMVC(new Date());
			
			// set a flag indicating an email should go out to the user
			request.SEND_COMPLETION_EMAIL = true;
			
			// set status to completed
			request.STATUS = 'Completed';
		}
		
		// convert checkboxes
		for (var i = 0; i < checkboxes.length; i++) {
			request[checkboxes[i]] = request[checkboxes[i]] ? 1 : null;
		}
		
		// flourine only gets a value if it is non-empty
		if (!this.isEmpty(request.FLOURINE)) {
			// why is this being converted to a string
			request.FLOURINE = request.FLOURINE === 'true' ? 1 : null;
		}

		// set ID sequence if this is a new request
		if (!this.props.params.requestId) {
			request.ID = 'microrequest_id_seq.nextval';
		}
		
		// if no status yet
		if (this.isEmpty(request.STATUS)) {
			// set to submitted
			request.STATUS = 'Submitted';
		} else if (request.STATUS === 'Submitted') {
			// if it's already been submitted, set to updated
			request.STATUS = 'Updated';
		}

		this.ajax({
			type: 'post',
			url: this.getConfig().host + '/FAS/UpdateMicrorequest',
			data: { 
				__RequestVerificationToken: this.props.user.antiForgeryToken,
				request: request
			}
		}).done(function (data) {
			if (data.Success) {
				self.props.parent.showConfirmation(() => {
					var requestId = self.props.params.requestId || data.ID;
					var verb = self.props.params.requestId ? 'updated' : 'added';
					return (<>
						Request <Link to={'/FAS/Microrequests/' + requestId}>{requestId}</Link> {verb}.
					</>);
				});				
			} else {
				self.showAlert('Server Error', data.Message);
			}			
		}).fail(function (jqXHR, textStatus, errorThrown) {
			self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
		});
	}
	
	renderAnalysisRequested(props) {
		return (<div style={{ fontWeight: 'bold', marginTop: '6px', marginBottom: '20px' }}>Analysis Requested</div>);
	}

	renderCheckboxes(props) {
		// add optional disabled props
		var addlProps = {};
		if (!this.isEditable()) addlProps.disabled = 'disabled';
		return (<>
			<div style={{ fontWeight: 'bold', marginTop: '6px' }}>Mark all that apply</div>
			<Container fluid>
				<Row>
					<Col>
						<ADACheckbox style={{ paddingTop: '8px' }} {...addlProps}
							checked={this.getByAccessor(this.state.request, 'microrequest.VOLATILE')} label='Volatile'
							onClick={(event) => this.onChange('microrequest.VOLATILE', event.target.checked)} />
					</Col>
					<Col>
						<ADACheckbox style={{ paddingTop: '8px' }} {...addlProps}
							checked={this.getByAccessor(this.state.request, 'microrequest.HYPER')} label='Hygroscopic - weigh quick'
							onClick={(event) => this.onChange('microrequest.HYPER', event.target.checked)} />
					</Col>
					<Col>
						<ADACheckbox style={{ paddingTop: '8px' }} {...addlProps}
							checked={this.getByAccessor(this.state.request, 'microrequest.AIRSEN')} label='Air Sensitive - Glove Box'
							onClick={(event) => this.onChange('microrequest.AIRSEN', event.target.checked)} />
					</Col>
				</Row>
				<Row>
					<Col>
						<ADACheckbox style={{ paddingTop: '8px' }} {...addlProps}
							checked={this.getByAccessor(this.state.request, 'microrequest.REFERSAM')} label='Refrigerate - sample'
							onClick={(event) => this.onChange('microrequest.REFERSAM', event.target.checked)} />
					</Col>
					<Col>
						<ADACheckbox style={{ paddingTop: '8px' }} {...addlProps}
							checked={this.getByAccessor(this.state.request, 'microrequest.FREZSAM')} label='Freeze sample'
							onClick={(event) => this.onChange('microrequest.FREZSAM', event.target.checked)} />
					</Col>
					<Col>
						<ADACheckbox style={{ paddingTop: '8px' }} {...addlProps}
							checked={this.getByAccessor(this.state.request, 'microrequest.EXPLO')} label='Explosive'
							onClick={(event) => this.onChange('microrequest.EXPLO', event.target.checked)} />
					</Col>
				</Row>
				<Row>
					<Col style={{ marginBottom: '14px' }}>
						<ADACheckbox style={{ paddingTop: '8px' }} {...addlProps}
							checked={this.getByAccessor(this.state.request, 'microrequest.TOXIC')} label='Toxic'
							onClick={(event) => this.onChange('microrequest.TOXIC', event.target.checked)} />
					</Col>
					<Col>
						<ADACheckbox style={{ paddingTop: '8px' }} {...addlProps}
							checked={this.getByAccessor(this.state.request, 'microrequest.ISOTO')} label='Isotopically Enriched'
							onClick={(event) => this.onChange('microrequest.ISOTO', event.target.checked)} />
					</Col>
					<Col>
						<ADACheckbox style={{ paddingTop: '8px' }} {...addlProps}
							checked={this.getByAccessor(this.state.request, 'microrequest.RADIO')} label='Radioactive'
							onClick={(event) => this.onChange('microrequest.RADIO', event.target.checked)} />
					</Col>
				</Row>
			</Container>
		</>);
	}
	
	renderAdminInfo(props) {
		if (this.props.user.fas.authLevel === 1) {
		  return (
			<Container style={{ backgroundColor: '#cccccc', marginBottom: '20px' }} fluid>
				<Row style={{ backgroundColor: '#9e9ecf' }}>
					<Col className='text-center' style={{ fontWeight: 'bold', marginTop: '6px', marginBottom: '6px' }}>
						Facilities Administrator Information
					</Col>
				</Row>
				<Row>
					<Col>
						<ChemEdit parent={this} user={this.props.user} columns={adminColumns} data={this.state.request}
							onChange={(accessor, value) => this.onChange(accessor, value)} renderKey={this.state.renderKey}
							editable={this.props.editable} />
					</Col>
				</Row>
			</Container>
		  );
		} else if (this.state.request.microrequest.ICP === 1) {
		  return (
			<Container style={{ backgroundColor: '#cccccc', marginBottom: '20px' }} fluid>
				<Row style={{ backgroundColor: '#9e9ecf' }}>
					<Col className='text-center' style={{ fontWeight: 'bold', marginTop: '6px', marginBottom: '6px' }}>
						Enter Hours When Completed
					</Col>
				</Row>
				<Row>
					<Col>
						<ChemEdit parent={this} user={this.props.user} columns={icpHoursColumns} data={this.state.request}
							onChange={(accessor, value) => this.onChange(accessor, value)} renderKey={this.state.renderKey}
							editable={this.isICPEditable()}/>
					</Col>
				</Row>
			</Container>
		  );
		}
	}
	
	renderCompleteCheckbox(props) {
	  var addlProps = {};
	  if (!this.isEditable()) addlProps.disabled = 'disabled';
	  return (
	    <Container fluid>
		  <Row>
		    <Col xs={{ offset: 1, span: 11 }}>
			  <ADACheckbox style={{ paddingTop: '8px' }} {...addlProps}
				checked={this.getByAccessor(this.state.request, 'microrequest.COMPLETE')}
				label='Check box if this recharge request is complete.'
				onClick={(event) => this.onChange('microrequest.COMPLETE', event.target.checked)} />
			</Col>
		  </Row>
		</Container>
	  );
	}
	
	renderCHNSRow(elem, idx) {
		// add optional disabled props
		var addlEstimProps = {};
		if (!this.isEditable()) addlEstimProps.disabled = 'disabled';
		var addlFoundProps = {};
		if (!this.isEditable() || ('' + this.props.user.uid).startsWith('fas.user.')) addlFoundProps.disabled = 'disabled';
		return (
			<Row style={{ paddingTop: 5, marginBottom: -10, borderTop: '1px solid #eee'}}>
				<Col xs={1} style={{ marginTop: '6px', marginBottom: '8px' }}>
					{elem}
				</Col>
				<Col xs={2} style={{ marginBottom: '14px' }}>
					<Form.Control className={classBorderControl} type='text' {...addlEstimProps}
						value={this.getByAccessorForInput(this.state.request, 'microrequest.ESTIMATED' + idx)}
						onChange={(event) => this.onChange('microrequest.ESTIMATED' + idx, event.target.value)} />
				</Col>
				<Col xs={{ span: 2, offset: 1 }} style={{ marginBottom: '14px' }}>
					<Form.Control className={classBorderControl} type='text' {...addlFoundProps}
						value={this.getByAccessorForInput(this.state.request, 'microrequest.FOUND' + (idx * 2 - 1))}
						onChange={(event) => this.onChange('microrequest.FOUND' + (idx * 2 - 1), event.target.value)} />
				</Col>
				<Col xs={{ span: 2, offset: 1 }} style={{ marginBottom: '14px' }}>
					<Form.Control className={classBorderControl} type='text' {...addlFoundProps}
						value={this.getByAccessorForInput(this.state.request, 'microrequest.FOUND' + (idx * 2))}
						onChange={(event) => this.onChange('microrequest.FOUND' + (idx * 2), event.target.value)} />
				</Col>				
			</Row>
		);
	}
	
	renderCHNSGrid(props) {
		return (
			<Container fluid style={{ marginBottom: '10px' }}>
				<Row style={{ paddingTop: 5, marginBottom: -10 }}>
					<Col xs={{ span: 2, offset: 1 }} style={{ marginBottom: '14px', fontWeight: 'bold' }}>
						% Estimated
					</Col>
					<Col xs={{ span: 2, offset: 1 }} style={{ marginBottom: '14px', fontWeight: 'bold' }}>
						% Found
					</Col>
					<Col xs={{ span: 2, offset: 1 }} style={{ marginBottom: '14px', fontWeight: 'bold' }}>
						% Found
					</Col>				
				</Row>
				{this.renderCHNSRow('C', 1)}
				{this.renderCHNSRow('H', 2)}
				{this.renderCHNSRow('N', 3)}
				{this.renderCHNSRow('S', 4)}
			</Container>
		);
	}
	
	render() {	
	
		var pdfData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			id: this.props.params.requestId,
			userid: this.props.params.userId
		});	
		
		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', paddingBottom: '10px', border: '1px solid #ccc', backgroundColor: '#FEFEFE' }}>
				  <Container fluid>
					<Row>
					  <Col xs={11}>
						<div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>
						  MICROANALYTICAL Request {this.state.request.microrequest.IDDISPLAY} - {this.state.request.users.AFFILIATIONDISPLAY}
						</div>
						Fields with <font color="red">*</font> are required
					  </Col>
					  <Col xs={1}>
					  	<form action={this.getConfig().host + '/FAS/MicrorequestPDF'} method='POST' target='_blank'>
							{pdfData.map((pdfFormField, index) => {
								return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Download PDF</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Download PDF" />
							</OverlayTrigger>
						</form>
					  </Col>
					</Row>
					<Row>
					  <Col style={{ paddingBottom: '10px' }}>
						<ChemEdit parent={this} user={this.props.user} columns={this.state.requestColumns} data={this.state.request}
							onChange={(accessor, value) => this.onChange(accessor, value)} renderKey={this.state.renderKey}
							validate={(event, columns, data) => this.validateRequest(event, columns, data)}
							onSubmit={(event) => this.onSubmit(event)} editable={this.isEditable()}>
							<Form.Group as={Row}>
							  <Col style={{ borderTop: '1px solid #eee', paddingTop: '5px' }}>
								{(this.isEditable() || this.isICPEditable()) && <Button id="save" style={{ marginLeft: '10px' }}
									variant="warning" type="submit" className="float-end">Save</Button>}
								{this.isDeletable() && <Button id="delete" variant="warning" type="button"
									onClick={() => this.onClickDelete()} className="float-end">Delete</Button>}
							  </Col>
							</Form.Group>							
						</ChemEdit>
					  </Col>
					</Row>
				  </Container>
				</Col>
			  </Row>
			</Container>
		</>);
	}
}

const requestColumns = [
	{ Header: 'Request Date', accessor: 'microrequest.REQUESTDATE', type: 'date', row: 0, col: 0, editable: false },
	{ Header: 'Request No.', accessor: 'microrequest.IDDISPLAY', row: 0, col: 1, editable: false },
	{ Header: 'Complete Date', accessor: 'microrequest.DATECOMP', type: 'date', row: 1, col: 0, editable: false },
	{ Header: 'Billing Date', accessor: 'microrequest.BILLINGDATE', type: 'date', row: 1, col: 1, editable: false },
	{ Header: 'First Name', accessor: 'users.FIRSTNAME', row: 2, col: 0, editable: false },
	{ Header: 'Last Name', accessor: 'users.LASTNAME', row: 2, col: 1, editable: false },
	{ Header: 'PI Group', accessor: 'users.PIGRPNAME', row: 3, col: 0, includedby: 'chem', editable: false },
	{ Header: 'Faculty Advisor', accessor: 'users.PINAME', row: 3, col: 0, includedby: 'affil', editable: false },
	{ Header: 'Organization', accessor: 'users.ORGANIZATION', row: 3, col: 0, includedby: 'non', editable: false },
	{ Header: 'Phone Number', accessor: 'users.PHONE', row: 3, col: 1, editable: false },
	{ Header: 'Sample Code', accessor: 'microrequest.SAMPLECODE', row: 4, col: 0, required: true },
	{ Header: 'Campus Address', accessor: 'users.ROOMBUILD', row: 4, col: 1, editable: false },
	{ Header: 'Purchase Order', accessor: 'microrequest.PONUMBER', row: 5, col: 0, includedby: 'non', required: true },
	{ Header: 'Speedtype', accessor: 'microrequest.SPEEDCODE', row: 5, col: 0, includedby: ['chem','affil'], required: true },
	{ Header: 'Email Address', accessor: 'users.USERNAME', row: 5, col: 1, editable: false },
	{ Header: 'Chartstring', accessor: 'microrequest.PONUMBER', row: 6, col: 0, includedby: ['chem','affil'], required: true },
	{ Header: 'Service', accessor: 'microrequest.SERVICE', type: 'select', row: 6, col: 1, required: true,
		options: [{ value: null, label: 'Select...' },
			{ value: 'CHN', label: 'CHN' },{ value: 'CHNA', label: 'CHN (air-sensitive)' },
			{ value: 'CHNS', label: 'CHNS' },{ value: 'CHNS+CHNA', label: 'CHNS (air-sensitive)' },
			{ value: 'ICP', label: 'ICP' },{ value: 'Consulting', label: 'Consulting' }]},
	{ Header: 'Is this an ICP request?', accessor: 'microrequest.ICP', type: 'select', row: 7, col: 0, required: true,
		options: [{ value: 0, label: 'No' }, { value: 1, label: 'Yes' }]},
	{ Header: 'Contains Flourine', accessor: 'microrequest.FLOURINE', type: 'select', row: 7, col: 1, required: true,
		options: [{ value: null, label: 'Select...' },{ value: false, label: 'No' }, { value: true, label: 'Yes' }]},
	{ Header: 'Amount Submitted', accessor: 'microrequest.AMTSUBMITTED', row: 8, col: 0, includedby: 'icpno', required: true },
	{ Header: 'Molecular Formula', accessor: 'microrequest.MOLFORMULA', row: 8, col: 1, includedby: 'icpno', required: true },
	{ Header: 'Sample Color', accessor: 'microrequest.SAMPLECOLOR', row: 9, col: 0, includedby: 'icpno', required: true },
	{ Header: 'Molecular Weight', accessor: 'microrequest.MOLWEIGHT', row: 9, col: 1, includedby: 'icpno', required: true },
	{ Header: 'Melting Point', accessor: 'microrequest.MELTPOINT', row: 10, col: 0 },
	{ Header: 'Boiling Point', accessor: 'microrequest.BOILPOINT', row: 10, col: 1 },
	{ Editor: props => props.parent.renderAnalysisRequested(props), row: 11, col: 0 },
	{ Header: 'Duplicate if Δ <', accessor: 'microrequest.DUPLESS', row: 12, col: 0 },
	{ Header: 'Duplicate if Δ >', accessor: 'microrequest.DUPMORE', row: 12, col: 1 },
	{ Editor: props => props.parent.renderCheckboxes(props), row: 13, col: 0, colwidth: 12 },
	{ Editor: props => props.parent.renderAdminInfo(props), row: 14, col: 0, colwidth: 12 },
	{ Editor: props => props.parent.renderCHNSGrid(props), row: 15, col: 0, colwidth: 12 },
	{ Header: 'Notes/ICP Scheduling Request', accessor: 'microrequest.NOTES', type: 'textarea', row: 16, col: 0, colwidth: 12 }
];

const adminColumns = [
	{ Header: 'Amount', accessor: 'microrequest.SERVICEAMOUNT', row: 0, col: 0 },
	{ Header: 'Request', accessor: 'microrequest.IDDISPLAY', row: 0, col: 2 },
	{ Header: 'Labor', accessor: 'microrequest.LABOR', row: 1, col: 0 },
	{ Header: 'Materials', accessor: 'microrequest.MATERIALS', row: 1, col: 1 },
	{ Header: 'Service Total', accessor: 'microrequest.SERVICETOTAL', row: 1, col: 2 },
	{ Header: 'Billing Code', accessor: 'microrequest.BILLINGCODE', row: 2, col: 0 },
	{ Editor: props => props.parent.renderCompleteCheckbox(props), row: 2, col: 1, colwidth: 8 }
];

const icpHoursColumns = [
	{ Header: 'Hours', accessor: 'microrequest.SERVICEAMOUNT', row: 0, col: 0, colwidth: 6 }
];

const checkboxes = ['VOLATILE','HYPER','AIRSEN','REFERSAM','FREZSAM','EXPLO','TOXIC','ISOTO','RADIO','COMPLETE'];

const classBorderControl = 'border border-secondary';

export default withRouter(Microrequest);
